import { VUE_PATHS } from "@/lib/routes";
import type { Facture, Mouvement, Produit, Rapprochement } from "./types";

export const PRODUITS_INIT: Produit[] = [
  { ref: "MOT-16HDI-92", nom: "Moteur 1.6 HDi 92 ch", emp: "A-01-1", qte: 6, seuil: 3, pa: 1450 },
  { ref: "MOT-15DCI-110", nom: "Moteur 1.5 dCi 110 ch", emp: "A-01-2", qte: 2, seuil: 3, pa: 1380 },
  { ref: "MOT-12PT-110", nom: "Moteur 1.2 PureTech 110 ch", emp: "A-02-1", qte: 9, seuil: 4, pa: 1290 },
  { ref: "MOT-20TDI-150", nom: "Moteur 2.0 TDI 150 ch", emp: "A-02-2", qte: 0, seuil: 2, pa: 2150 },
  { ref: "MOT-10TSI-95", nom: "Moteur 1.0 TSI 95 ch", emp: "A-03-1", qte: 4, seuil: 2, pa: 1190 },
  { ref: "TUR-16HDI", nom: "Turbo 1.6 HDi", emp: "B-01-3", qte: 14, seuil: 5, pa: 310 },
  { ref: "TUR-15DCI", nom: "Turbo 1.5 dCi", emp: "B-01-3", qte: 3, seuil: 5, pa: 295 },
  { ref: "BV5-MA-16", nom: "Boîte de vitesses manuelle 5 rapports", emp: "B-02-1", qte: 5, seuil: 2, pa: 640 },
  { ref: "BV6-20TDI", nom: "Boîte de vitesses 6 rapports 2.0 TDI", emp: "B-02-2", qte: 1, seuil: 2, pa: 890 },
  { ref: "INJ-16HDI-X4", nom: "Jeu de 4 injecteurs 1.6 HDi", emp: "C-01-1", qte: 22, seuil: 8, pa: 420 },
  { ref: "POMP-HP-15DCI", nom: "Pompe haute pression 1.5 dCi", emp: "C-01-2", qte: 7, seuil: 4, pa: 265 },
  { ref: "ALT-12V-150A", nom: "Alternateur 12 V 150 A", emp: "C-02-1", qte: 18, seuil: 6, pa: 145 },
  { ref: "DEM-12PT", nom: "Démarreur 1.2 PureTech", emp: "C-02-2", qte: 11, seuil: 6, pa: 118 },
  { ref: "KIT-DIST-16HDI", nom: "Kit distribution 1.6 HDi", emp: "C-03-1", qte: 31, seuil: 10, pa: 96 },
];

export const MOUVEMENTS_INIT: Mouvement[] = [
  { quand: "Aujourd'hui 18:52", type: "vente", ref: "INJ-16HDI-X4", delta: -1, source: "F-2026-0418 · PrestaShop" },
  { quand: "Aujourd'hui 17:10", type: "vente", ref: "MOT-15DCI-110", delta: -1, source: "F-2026-0417 · Magasin" },
  { quand: "Aujourd'hui 10:31", type: "reception", ref: "KIT-DIST-16HDI", delta: 12, source: "BL Grossiste A" },
  { quand: "Aujourd'hui 10:31", type: "reception", ref: "ALT-12V-150A", delta: 6, source: "BL Grossiste A" },
  { quand: "Hier 16:04", type: "vente", ref: "MOT-20TDI-150", delta: -1, source: "F-2026-0412 · PrestaShop" },
  { quand: "Hier 09:15", type: "inventaire", ref: "TUR-15DCI", delta: -1, source: "Recomptage allée B" },
];

export const FACTURES_INIT: Facture[] = [
  {
    num: "F-2026-0418",
    quand: "12/10 · 18:52",
    canal: "PrestaShop",
    lignes: [{ ref: "INJ-16HDI-X4", texte: "Jeu de 4 injecteurs 1.6 HDi", qte: 1, statut: "ok" }],
  },
  {
    num: "F-2026-0417",
    quand: "12/10 · 17:10",
    canal: "Magasin",
    lignes: [
      { ref: "MOT-15DCI-110", texte: "Moteur 1.5 dCi 110 ch", qte: 1, statut: "ok" },
      { ref: null, texte: "Turbo occasion 1.6 diesel", qte: 1, statut: "associer", id: "l1" },
    ],
  },
  {
    num: "F-2026-0415",
    quand: "12/10 · 11:46",
    canal: "Magasin",
    lignes: [
      { ref: null, texte: "Alternateur 150A Valeo", qte: 2, statut: "associer", id: "l2" },
      { ref: null, texte: "Main d'œuvre pose", qte: 1, statut: "ignore" },
    ],
  },
  {
    num: "F-2026-0412",
    quand: "11/10 · 16:04",
    canal: "PrestaShop",
    lignes: [{ ref: "MOT-20TDI-150", texte: "Moteur 2.0 TDI 150 ch", qte: 1, statut: "ok" }],
  },
];

export const RAPPROCHEMENTS_INIT: Rapprochement[] = [
  {
    id: "r1",
    fournisseur: "Grossiste A",
    mois: "Septembre 2026",
    facture: "FA-88412",
    verifie: false,
    lignes: [
      { ref: "MOT-16HDI-92", recu: 4, facture: 4, puCmd: 1450, puFact: 1450 },
      { ref: "TUR-15DCI", recu: 6, facture: 8, puCmd: 295, puFact: 295 },
      { ref: "KIT-DIST-16HDI", recu: 20, facture: 20, puCmd: 96, puFact: 104 },
      { ref: "ALT-12V-150A", recu: 10, facture: 10, puCmd: 145, puFact: 145 },
    ],
  },
  {
    id: "r2",
    fournisseur: "Grossiste B",
    mois: "Septembre 2026",
    facture: "GB-2026-0931",
    verifie: false,
    lignes: [
      { ref: "BV5-MA-16", recu: 3, facture: 3, puCmd: 640, puFact: 640 },
      { ref: "DEM-12PT", recu: 8, facture: 8, puCmd: 118, puFact: 118 },
    ],
  },
];

export const VUES = [
  {
    id: "accueil" as const,
    path: VUE_PATHS.accueil,
    lib: "Accueil",
    court: "Accueil",
    eyebrow: "Vue d'ensemble",
  },
  {
    id: "stock" as const,
    path: VUE_PATHS.stock,
    lib: "Stock",
    court: "Stock",
    eyebrow: "Articles et emplacements",
  },
  {
    id: "reception" as const,
    path: VUE_PATHS.reception,
    lib: "Réceptions",
    court: "Réception",
    eyebrow: "Entrées de marchandise",
  },
  {
    id: "ventes" as const,
    path: VUE_PATHS.ventes,
    lib: "Ventes Pennylane",
    court: "Ventes",
    eyebrow: "Sorties automatiques",
  },
  {
    id: "fournisseurs" as const,
    path: VUE_PATHS.fournisseurs,
    lib: "Contrôle factures",
    court: "Factures",
    eyebrow: "Factures fournisseurs ↔ réceptions",
  },
  {
    id: "fournisseursConfig" as const,
    path: VUE_PATHS.fournisseursConfig,
    lib: "Fournisseurs",
    court: "Fourn.",
    eyebrow: "Qui entre en stock",
  },
  {
    id: "inventaire" as const,
    path: VUE_PATHS.inventaire,
    lib: "Inventaire",
    court: "Inventaire",
    eyebrow: "Saisie tableau ou par allée",
  },
  {
    id: "associations" as const,
    path: VUE_PATHS.associations,
    lib: "Ventes ↔ Achats",
    court: "Associer",
    eyebrow: "Produits achetés liés aux produits vendus",
  },
  {
    id: "fusions" as const,
    path: VUE_PATHS.fusions,
    lib: "Fusionner produits",
    court: "Fusion",
    eyebrow: "Doublons Pennylane à regrouper",
  },
  {
    id: "achatsProduits" as const,
    path: VUE_PATHS.achatsProduits,
    lib: "Produits achats",
    court: "Achats",
    eyebrow: "Libellés, fusions et prix d'achat",
  },
];

export const TYPE_LIB = {
  vente: "Vente",
  reception: "Réception",
  inventaire: "Inventaire",
  correction: "Correction",
} as const;
